export default "<img width=\"100%\" src=\"/static/images/banner_demo.png\">\n"